import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/articles/[slug]/ArticleClientPage.jsx");
